import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export function get_file_url(path: string, type?: string): any {
  if (type == "local") {
    return BASE_URL + path;
  } else if (type == "s3") {
    return path;
  } else if (path.startsWith("http")) {
    return path;
  } else{
    return BASE_URL + path;
  }
}
